export default [
  {
    question: "Terms & Conditions or FAQ",
    answer: "Promocode Details : <b>WELCOME10</b><br/>" +
      "Up to RM10 off<br/>" +
      "No Minimum Spend<br/>" +
      "<ol><li>This Promo Code WELCOME10 is only valid in Malaysia from 10th September 00:00hrs till 31st December 23:59hrs.</li>" +
      "<li>Limited to ONE (1) time redemption per login User, on a first-come-first-serve basis.</li>" +
      "<li>To redeem the discount, User must login and enter the Promo code at ‘Cart Page’ before ‘Payment Page’.</li>" +
      "<li>This discount will be offset against the total checkout amount inclusive of delivery charges.</li>" +
      "<li>Free delivery charge is only applicable for checkout amounts above RM60.</li>" +
      "<li>This Promo Code is only applicable for products purchased on airasia grocer Malaysia and is within delivery coverage of up to 40km between Merchant and User.</li>" +
      "<li>Same Day Delivery applies for orders made before 12pm. Orders made after 12pm will be sent out the following day.</li>" +
      "<li>In the event of a refund, only the amount paid after discount will be refunded.</li>" +
      "<li>airasia grocer reserves the right to amend the Terms & Conditions of this promotion at any time without prior notice.</li>" +
      "<li>airasia grocer decision on all matters relating or in connection with this Promotion and these Terms and Conditions shall be final. No correspondence or claims will be entertained.</li>" +
      "<li>airasia grocer shall not in any event be liable in any way to you or any person for any loss, liability, damages or expenses whatsoever, however arising, in connection with this Promotion.</li></ol>",
  },
  
]
